<script setup>
import { defineProps, defineEmits } from 'vue';
import HeaderIcon from './HeaderIcon.vue';

const props = defineProps({
    menuItems: {
        type: Array,
        required: true,
    },
    activeMenuCode: {
        type: String,
        default: null,
    },
    activeThirdMenu: {
        type: Boolean,
        default: false,
    },
    activePath: {
        type: String,
        default: null,
    },
    isMobile: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['select-item']);

const handleItemClick = (code, name) => {
    emit('select-item', code, name);
};
</script>

<template>
    <!-- Desktop -->
    <div v-if="!isMobile && activePath !== '/'" class="header__container">
        <nav class="second-level-menu__nav">
            <template v-for="item in menuItems" :key="item.code">
                <a
                    v-if="item?.url"
                    class="second-level-menu__item second-level-menu__link"
                    :href="item.url"
                    :target="item._blank === 'Y' ? '_blank' : '_self'"
                    @click="handleItemClick(item.code, item.name)"
                    :class="{
                        'second-level-menu__link--active':
                            item.code === activeMenuCode,
                    }"
                >
                    {{ item.name }}
                </a>

                <div
                    v-else
                    class="second-level-menu__item second-level-menu__link"
                    @click.stop="handleItemClick(item.code, item.name)"
                    :class="{
                        'second-level-menu__link--active':
                            item.code === activeMenuCode,
                        'second-level-menu__link--open': activeThirdMenu,
                    }"
                >
                    {{ item.name }}
                    <header-icon name="arrow-down" />
                </div>
            </template>
        </nav>
    </div>

    <!-- Mobile -->
    <nav v-if="isMobile" class="second-level-menu__mobile">
        <template v-for="item in menuItems" :key="item.code">
            <a
                v-if="item?.url"
                class="second-level-menu__item second-level-menu__link"
                :class="{
                        'second-level-menu__link--active':
                            item.code === activeMenuCode,
                    }"
                :href="item.url"
                :target="item._blank === 'Y' ? '_blank' : '_self'"
                @click="handleItemClick(item.code, item.name)"
            >
                {{ item.name }}
            </a>

            <div
                v-else
                class="second-level-menu__link second-level-menu__link--with-icon"
                @click.stop="handleItemClick(item.code, item.name)"
            >
                {{ item.name }}

                <div class="second-level-menu__link__icon">
                    <header-icon name="arrow-right" />
                </div>
            </div>
        </template>

        <div class="second-level-menu__contact">
            <div class="second-level-menu__contact-section">
                <div class="second-level-menu__contact-title">
                    Телефон направления<br />Реализация федерального имущества
                </div>

                <a
                    class="second-level-menu__contact-phone"
                    href="tel:88007700001"
                    >8 (800) 770-00-01</a
                >
            </div>

            <div class="second-level-menu__contact-section">
                <div class="second-level-menu__contact-title">
                    Консультационный центр
                </div>

                <a
                    class="second-level-menu__contact-phone"
                    href="tel:88007555555"
                    >8 (800) 755-55-55</a
                >
            </div>

            <div class="second-level-menu__contact-section">
                <div class="second-level-menu__contact-address">
                    <div class="second-level-menu__contact-label">Адрес</div>

                    <div class="second-level-menu__contact-text">
                        Москва, Воздвиженка,10
                    </div>
                </div>

                <div class="second-level-menu__contact-social">
                    <a href="https://t.me/domrf_life" target="_blank" class="second-level-menu__contact-social-link">
                        <header-icon
                            name="telegram"
                            class="second-level-menu__contact-social-icon"
                        />
                    </a>

                    <a href="https://vk.com/domrf" target="_blank" class="second-level-menu__contact-social-link">
                        <header-icon
                            name="vk"
                            class="second-level-menu__contact-social-icon"
                        />
                    </a>

                    <a href="https://www.youtube.com/channel/UCgUs7ebuhG19V4yxDNe_2GQ" target="_blank" class="second-level-menu__contact-social-link">
                        <header-icon
                            name="youtube"
                            class="second-level-menu__contact-social-icon"
                        />
                    </a>
                </div>
            </div>
        </div>
    </nav>
</template>
